import { XO_SESSION_TOKEN } from '@constants/membership';
import { useAppDispatch, useAppSelector } from '@redux/hooks';
import { fetchWedding } from '@redux/wedding';
import { CookieStorage } from 'cookie-storage';
import { useEffect } from 'react';

export const useFetchWedding = (memberId?: string) => {
	const dispatch = useAppDispatch();
	const weddingId = useAppSelector((state) => state.wedding.id);

	useEffect(() => {
		if (!memberId || weddingId) return;

		const sessionToken = new CookieStorage().getItem(XO_SESSION_TOKEN);
		if (!sessionToken) return;

		dispatch(fetchWedding(memberId, sessionToken));
	}, [dispatch, memberId, weddingId]);
};
